module.exports = __webpack_public_path__ + "img/allif-tv-screen.8b4d64b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/allif-tv-screen.svg
// module id = 1617
// module chunks = 1